import Vue from 'vue';
import { weekdaysShort, months } from 'moment';

import {
  ConfigProgrammatic,
  Progress,
  Icon,
  Dialog,
  Autocomplete,
  Field,
  Datepicker,
  Radio,
  Input,
  Pagination,
  Select,
  Modal,
  Notification,
  Table,
  Checkbox,
  Loading,
} from 'buefy';

Vue.use(Progress);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Field);
Vue.use(Datepicker);
Vue.use(Radio);
Vue.use(Input);
Vue.use(Pagination);
Vue.use(Select);
Vue.use(Modal);
Vue.use(Notification);
Vue.use(Table);
Vue.use(Checkbox);
Vue.use(Loading);

ConfigProgrammatic.setOptions({
  defaultDayNames: weekdaysShort().map(
    (el) => `${el[0].toUpperCase()}${el.slice(1)}`
  ),
  defaultMonthNames: months().map(
    (el) => `${el[0].toUpperCase()}${el.slice(1)}`
  ),
});
